import { FC, ReactElement, useCallback } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { AutoComplete, Button, Divider, Form, Input, Modal, Space } from "antd";
import { FormattedMessage, useIntl } from "react-intl";
import MainCreationForm from "components/forms/MainCreationForm";
import ImageUploadField from "components/fields/ImageUploadField";

import { SeatMapFieldProps } from "./types";
import { useSeatMap, useSeatMapSelect } from "./hooks";
import { SEAT_MAP_FORM_INITIAL_VALUES } from "./consts";

const SeatMapField: FC<SeatMapFieldProps> = (props) => {
  const seatMapSelect = useSeatMapSelect(props);
  const intl = useIntl();
  const {
    isSeatMapLoading,
    isSeatMapModalOpen,
    onSeatMapFormSubmit,
    onSeatMapValuesChange,
    seatMapForm,
    setIsSeatMapModalOpen,
  } = useSeatMap(seatMapSelect.onChange);
  const dropdownRender = useCallback(
    (menu: ReactElement) => (
      <>
        {menu}
        <Divider style={{ margin: "8px 0" }} />
        <Space>
          <Modal
            title={intl.formatMessage({
              defaultMessage: "Seat Map",
            })}
            confirmLoading={isSeatMapLoading}
            open={isSeatMapModalOpen}
            onOk={seatMapForm.submit}
            onCancel={() => setIsSeatMapModalOpen(false)}
            okText={intl.formatMessage({
              defaultMessage: "Add new Seat Map",
            })}
          >
            <MainCreationForm
              onFinish={onSeatMapFormSubmit}
              initialValues={SEAT_MAP_FORM_INITIAL_VALUES}
              form={seatMapForm}
              onValuesChange={onSeatMapValuesChange}
              disabled={isSeatMapLoading}
            >
              <Form.Item
                label={intl.formatMessage({
                  defaultMessage: "Seat Map Name",
                })}
                name={["input", "name"]}
                required
              >
                <Input />
              </Form.Item>
              <Form.Item
                label={intl.formatMessage({
                  defaultMessage: "Image",
                })}
                name={["input", "image"]}
              >
                <ImageUploadField />
              </Form.Item>
            </MainCreationForm>
          </Modal>
          <Button
            type="text"
            icon={<PlusOutlined />}
            onClick={() => setIsSeatMapModalOpen(true)}
          >
            <FormattedMessage defaultMessage="Add item" />
          </Button>
        </Space>
      </>
    ),
    [
      intl,
      isSeatMapLoading,
      isSeatMapModalOpen,
      onSeatMapFormSubmit,
      onSeatMapValuesChange,
      seatMapForm,
      setIsSeatMapModalOpen,
    ]
  );

  return (
    <AutoComplete
      {...{
        ...seatMapSelect,
        dropdownRender,
      }}
      placeholder={intl.formatMessage({
        defaultMessage: "Choose seat map",
      })}
    />
  );
};

export default SeatMapField;
